<div class="cm-title">
    @if ($collapsable()) {
        <i class="cm-background-operations-header-icon fa-regular {{ $isCollapsed() ? 'fa-chevron-up' : 'fa-chevron-down' }}" (click)="toggle()"></i>
    }
    <ng-content select="[cm-title]"></ng-content>
</div>
@if (!$collapsable() || !$isCollapsed()) {
    <div [class]="$allowOverflow() ? 'cm-content-with-overflow' : 'cm-content'">
        <ng-content select="[cm-content]"></ng-content>
    </div>
}
